import { Component, OnInit,AfterViewInit, Input } from "@angular/core";
@Component({
  selector: "placeRow",
  templateUrl: './placeRow.component.html',
  styleUrls: ["./placeRow.component.scss"]
})
export class placeRowComponent implements OnInit, AfterViewInit {
 
  @Input() model: any;
  @Input() value: any;

  public constructor() {
  }
  public ngOnInit(): void { }

  public ngAfterViewInit(): void { }

}


// WEBPACK FOOTER //
// ./src/app/component/blocks/placeRow/placeRow.component.ts